import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { fetchConsentFormTemplate } from "../api/consentFormService";
import { DEFAULT_CONSENT_FORM_TEMPLATE } from "../utils/buildConsentHtml";

function getFacilityId() {
  const value = sessionStorage.getItem("facility_name");
  return value && value !== "null" && value !== "undefined" ? value : null;
}

let cachedTemplate = null;
let inflightRequest = null;

function loadConsentFormTemplate() {
  if (cachedTemplate) {
    return Promise.resolve(cachedTemplate);
  }
  if (inflightRequest) {
    return inflightRequest;
  }

  const facilityId = getFacilityId();
  if (!facilityId) {
    toast.error("Facility not found. Please log in again.");
    cachedTemplate = DEFAULT_CONSENT_FORM_TEMPLATE;
    return Promise.resolve(cachedTemplate);
  }

  inflightRequest = fetchConsentFormTemplate(facilityId)
    .then((template) => {
      cachedTemplate = template;
      return cachedTemplate;
    })
    .catch(() => {
      console.warn("Using default consent form — template could not be loaded.");
      cachedTemplate = DEFAULT_CONSENT_FORM_TEMPLATE;
      return cachedTemplate;
    })
    .finally(() => {
      inflightRequest = null;
    });

  return inflightRequest;
}

export function useConsentFormTemplate() {
  const [template, setTemplate] = useState(() => cachedTemplate || DEFAULT_CONSENT_FORM_TEMPLATE);

  useEffect(() => {
    let cancelled = false;

    loadConsentFormTemplate().then((nextTemplate) => {
      if (!cancelled && nextTemplate) {
        setTemplate(nextTemplate);
      }
    });

    return () => { cancelled = true; };
  }, []);

  return { template, ready: true };
}
